// extracted by mini-css-extract-plugin
module.exports = {"header":"_dialog_header__2mUoH","iconButton":"_dialog_iconButton__1Y7pS","icon":"_dialog_icon__3P7Tw","hideButton":"_dialog_hideButton__1QGVA","footer":"_dialog_footer__3l4-E"};